import { render, staticRenderFns } from "./adcarousel.vue?vue&type=template&id=8b90a24c&scoped=true"
import script from "./adcarousel.vue?vue&type=script&lang=js"
export * from "./adcarousel.vue?vue&type=script&lang=js"
import style0 from "./adcarousel.vue?vue&type=style&index=0&id=8b90a24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b90a24c",
  null
  
)

export default component.exports